import Swal from "sweetalert2";

const defaultLevels = [
  { role: "RH", level: "L1" },
  { role: "Admin", level: "L2" },
];

const buildLevelsListHtml = (levels = defaultLevels) =>
  levels
    .map(
      (item) =>
        `<li><strong>${item.role}</strong> (${item.level})</li>`
    )
    .join("");

export const requestApprovalWithReasonModal = async ({
  title = "Solicitar aprobación",
  actionLabel = "este proceso o acción",
  inputLabel = "Motivo de la solicitud",
  inputPlaceholder = "Explique brevemente la justificación...",
  confirmButtonText = "Enviar solicitud",
  cancelButtonText = "Cancelar",
  minReasonLength = 8,
  maxReasonLength = 500,
  levels = defaultLevels,
  includeAdminBypassNote = true,
} = {}) => {
  const levelsHtml = buildLevelsListHtml(levels);
  const bypassNoteHtml = includeAdminBypassNote
    ? `<p style="margin-top:8px; margin-bottom:0;">
        Nota: solo <strong>Admin</strong> puede saltar niveles, y únicamente si la política del proceso lo permite.
      </p>`
    : "";

  return Swal.fire({
    title,
    input: "textarea",
    inputLabel,
    html: `
      <div style="text-align:left; font-size:14px; line-height:1.45;">
        <p style="margin-bottom:8px;">
          <strong>Importante:</strong> ${actionLabel} requiere flujo de aprobación y no se ejecuta de inmediato.
        </p>
        <p style="margin-bottom:8px;">
          Este proceso o acción requiere los siguientes niveles de aprobación:
        </p>
        <ol style="padding-left:18px; margin-bottom:8px;">
          ${levelsHtml}
        </ol>
        <p style="margin-bottom:0;">
          La ejecución final ocurre únicamente cuando se completen todos los niveles.
        </p>
        ${bypassNoteHtml}
      </div>
    `,
    inputPlaceholder,
    inputAttributes: { maxlength: maxReasonLength },
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    preConfirm: (value) => {
      const reason = String(value || "").trim();
      if (reason.length < minReasonLength) {
        Swal.showValidationMessage(`El motivo debe tener al menos ${minReasonLength} caracteres.`);
        return false;
      }
      return reason;
    },
  });
};

export const showApprovalRequestCreatedAlert = async ({
  title = "Solicitud enviada correctamente",
  firstLevelLabel = "RH (L1)",
  secondLevelLabel = "Admin (L2)",
  pendingSubject = "La acción solicitada",
  levels = null,
} = {}) =>
  Swal.fire(title, (() => {
    const normalizedLevels = Array.isArray(levels) ? levels.filter(Boolean) : [];
    if (normalizedLevels.length <= 1) {
      const singleLabel = normalizedLevels[0] || firstLevelLabel;
      return `${pendingSubject} quedó registrada en ${singleLabel}. Se ejecutará cuando ese nivel apruebe.`;
    }
    const levelOne = normalizedLevels[0] || firstLevelLabel;
    const levelTwo = normalizedLevels[1] || secondLevelLabel;
    return `${pendingSubject} quedó registrada en ${levelOne}. Continuará a ${levelTwo}. Se ejecutará solo después de completar todos los niveles.`;
  })(), "success");
